export const changePassword = {
    title: '更改密码',
    oldPasswordLabel: '旧密码',
    newPasswordLabel: '新密码',
    confirmPasswordLabel: '重新输入新密码',
    password: '密码',
    save: '保存更改',
    cancel: '取消',
};
